import React from "react";
import type { Bank } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const BanksPage: React.FC = () => {
  return (
    <CrudPage<Bank>
      title="Bancos"
      endpoint="/modules/banks"
      searchPlaceholder="Buscar por nome ou codigo..."
      columns={[
        { label: "Codigo", render: (item) => item.code ?? "-" },
        { label: "Banco", render: (item) => item.name },
      ]}
      formFields={[
        { name: "code", label: "Codigo", type: "text" },
        { name: "name", label: "Nome", type: "text", required: true },
      ]}
      initialValues={{
        code: "",
        name: "",
      }}
      mapToPayload={(values) => ({
        code: values.code || null,
        name: values.name,
      })}
      permissionWrite="BANK_WRITE"
    />
  );
};
